import PhotoDetails from '../src/PhotoDetails.tsx';
export default PhotoDetails;
